import moment from '@tools/moment';
import { URL_GET_LAST_TIME_USER_ONLINE } from '@tools/routes/routes';
import requests from '@tools/requests-mixin';

const DELAY_ONLINE_USER = 10000;

export default {
  mixins: [ moment, requests ],
  data() {
    return {
      onlineUsers: [],
      setOfflineId: null,
      interlocutorLastOnline: null,
    };
  },
  computed: {
    interlocutor() {
      return this.displayedTimeline.interlocutor;
    },
    isInterlocutorOnline() {
      if (!this.interlocutor) {
        return false;
      }
      return this.onlineUsers.includes(this.interlocutor.id);
    },
    lastOnlineStatus() {
      if (!this.interlocutorLastOnline || !this.interlocutorLastOnline.date || this.isInterlocutorOnline) {
        return null;
      }

      const minutesUntilNow = this.getMinutesUntilNow(this.interlocutorLastOnline.date);
      if (minutesUntilNow < 0) {
        return null;
      }

      return this.transchoice('messaging.instant.delay', {
        count: minutesUntilNow,
        minutes: minutesUntilNow,
        hours: Math.floor(minutesUntilNow / 60),
        days: Math.floor(minutesUntilNow / 1440),
        weeks: Math.floor(minutesUntilNow / 10080),
      });
    },
  },
  watch: {
    isInterlocutorOnline() {
      if (this.interlocutor) {
        this.refreshInterlocutorLastOnline();
      }
    },
  },
  methods: {
    async getUsersOnline() {
      if (!window.mercure) {
        return;
      }
      const onlineSubscriptionUrl = new URL(window.mercure.public_url + window.mercure.online.subscription_url);
      const resp = await fetch(onlineSubscriptionUrl, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${window.mercure.online.jwt}`,
        },
      });
      const subscriptionCollection = await resp.json();
      subscriptionCollection.subscriptions.forEach((subscription) => {
        const userId = subscription.payload.user;
        if (!this.onlineUsers.includes(userId)) {
          this.onlineUsers.push(userId);
        }
      });

      const liveOnlineSubscriptionUrl = new URL(window.mercure.public_url);
      liveOnlineSubscriptionUrl.searchParams.append('lastEventID', subscriptionCollection.lastEventID);
      liveOnlineSubscriptionUrl.searchParams.append('topic', window.mercure.online.subscription_topic);
      liveOnlineSubscriptionUrl.searchParams.append('authorization', window.mercure.online.jwt);
      const eventSource = new EventSource(liveOnlineSubscriptionUrl);
      eventSource.onmessage = ({ data }) => {
        const dataParsed = JSON.parse(data);
        const userId = dataParsed.payload.user;
        if (dataParsed.active) {
          this.addOnlineUser(userId);
          if (this.setOfflineId) {
            clearTimeout(this.setOfflineId);
          }
          return;
        }
        this.setOfflineId = setTimeout(() => {
          this.removeOnlineUser(userId);
        }, DELAY_ONLINE_USER);
      };
    },
    removeOnlineUser(userId) {
      const index = this.onlineUsers.findIndex((element) => element === userId);
      if (index > -1) {
        this.onlineUsers.splice(index, 1);
      }
    },
    addOnlineUser(userId) {
      if (!this.onlineUsers.includes(userId)) {
        this.onlineUsers.push(userId);
      }
    },
    async refreshInterlocutorLastOnline() {
      if (this.isInterlocutorOnline || !this.interlocutor) {
        return;
      }

      this.interlocutorLastOnline = null;
      const endpoint = URL_GET_LAST_TIME_USER_ONLINE.replace('{id}', this.interlocutor.id);
      const lastTimeUserOnline = await this.get(endpoint)
        .then((response) => response.data);
      this.interlocutorLastOnline = lastTimeUserOnline.message.last_online_date;
    },
  },
};
